import { render, staticRenderFns } from "./AttachResourceDialogEmbedded.vue?vue&type=template&id=68550cc0&scoped=true"
import script from "./AttachResourceDialogEmbedded.vue?vue&type=script&lang=js"
export * from "./AttachResourceDialogEmbedded.vue?vue&type=script&lang=js"
import style0 from "./AttachResourceDialogEmbedded.vue?vue&type=style&index=0&id=68550cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68550cc0",
  null
  
)

export default component.exports